/** Список класу записаний як «Прізвище Ім'я». */
export function givenName(fullName: string): string {
  const parts = fullName.trim().split(/\s+/).filter(Boolean);
  return parts[parts.length - 1] || fullName;
}
